import * as React from 'react'

import './Timeline.css'

// import Icon from '../../Img/PDTM.svg'

import { Card, ICardProps } from '../Elements/Card'
import TimelineCard from '../Elements/TimelineCard'
import ToolCard from '../Elements/ToolCard';
import { IDropZone, IDropZoneProps } from '../IDropZone'

import * as _ from 'underscore'
import { Tool } from '../../Api/Tools';
import { ToolsManager } from '../ToolsManager';

import IModalOpenableProps from '../Modal/IModalOpenableProps';
import IDragStartChainable from '../IDragStartChainable';
import IDraggable from '../IDraggable';
import { ToolInstance } from '../ToolInstance';


interface ITimelineProps extends IDropZoneProps<Timeline>, IModalOpenableProps, IDragStartChainable {
    /* not empty */
}

interface ITimelineState {
    hasMouseInZone: boolean;
    activeSeparatorIndex: number;
    instances: ToolInstance[];
}

class Timeline extends React.Component<ITimelineProps, ITimelineState> implements IDropZone<Card<ICardProps, any>> {
    private bodyRef: any;
    private instanceCursor = new Date().getTime();

    private mouseMovedThrottled: any;
    private mouseMovedUsed: any;

    public constructor(props: ITimelineProps) {
        super(props);

        this.bodyRef = React.createRef();

        this.state = {
            hasMouseInZone: false,
            activeSeparatorIndex: -1,
            instances: []
        };

        this.mouseMovedThrottled = _.throttle(this.mouseMoved, 100);
        this.mouseMovedUsed = (event: React.MouseEvent) => {
            event.persist();
            this.mouseMovedThrottled(event);
        };
    }

    public render() {
        return (
            <div className="Timeline" onMouseEnter={this.mouseEntered} onMouseLeave={this.mouseLeft} onMouseMove={this.mouseMovedUsed}>
                <div className="Timeline__header">
                    <div className="Timeline__time-display">{this.renderTotalTime()}</div>
                </div>
                <div className={"Timeline__body-holder " + (!this.props.dragActive ? "Timeline__body-holder--no-drag" : "")}>
                    <div className="Timeline__body" ref={this.bodyRef}>
                        {this.renderCards()}
                    </div>
                </div>
            </div>
        );
    }

    public handleDrop(card: Card<ICardProps, any>) : void {
        if(card instanceof ToolCard) {

            const theTool: Tool | undefined = ToolsManager.getTool(card.props.toolId);
            if(!theTool) {
                return;
            }
            const proposedDefaultTime: number = theTool.timeDefault;

            const theNewInstance = new ToolInstance (
                (++this.instanceCursor).toString(),
                theTool.id,
                proposedDefaultTime,
                (t:number) => this.setState(prev => prev));

            const copy = this.state.instances;
            copy.splice(this.state.activeSeparatorIndex, 0, theNewInstance);
            this.setState({
                instances: copy
            });
        } else if(card instanceof TimelineCard) {
            const copy = this.state.instances;
            const theInstance = card.props.toolInstance;

            copy.splice(this.state.activeSeparatorIndex, 0, theInstance);
            this.setState({
                instances: copy
            });
        }
    }

    private renderCards() {
        const buffer: any[] = [];

        let separatorIndex = 0; // a fake key for separators, but hey, works as expected&&suppossed to

        let separatorActivityModifier = "";
        if(this.props.dragActive && this.state.activeSeparatorIndex === separatorIndex && this.state.hasMouseInZone) {
            separatorActivityModifier = "Timeline__separator--active";
        } else {
            separatorActivityModifier = "";
        }
        buffer.push(<div className={"Timeline__separator " + separatorActivityModifier} key={separatorIndex++} />);

        for(const instance of this.state.instances) {
            if(!instance) {
                continue;
            }

            const tool: Tool | undefined = ToolsManager.getTool(instance.toolId);
            if(!tool) {
                continue;
            }

            buffer.push(
                <TimelineCard
                    toolInstance={instance}
                    name={tool.name}
                    defaultTime={instance.time}

                    openModal={this.props.openModal}

                    key={"TimelineCard_" + instance.instanceId.toString()}
                    dragActive={this.props.dragActive}
                    onDragStart={this.dragStarted}
                    />
            );

            if(this.props.dragActive && this.state.activeSeparatorIndex === separatorIndex && this.state.hasMouseInZone) {
                separatorActivityModifier = "Timeline__separator--active";
            } else {
                separatorActivityModifier = "";
            }
            buffer.push(<div className={"Timeline__separator " + separatorActivityModifier} key={separatorIndex++} />);
        }

        return buffer;
    }

    private renderTotalTime() : string {
        let hours = Math.floor(this.getTotalTime() / 60).toString();
        let minutes = (this.getTotalTime() % 60).toString();

        if(hours.length === 1) {
            hours = "0" + hours;
        }

        if(minutes.length === 1) {
            minutes = "0" + minutes;
        }

        return hours + ":" + minutes;
    }

    private getTotalTime() : number {
        let sum: number = 0;

        for(const instance of this.state.instances) {
            sum += instance.time;
        }

        return sum;
    }

    private mouseEntered = () => {
        if(this.props.onDropZoneEnter) {
            this.props.onDropZoneEnter(this);
        }

        this.setState({
            hasMouseInZone: true
        });
    };

    private mouseLeft = () => {
        if(this.props.onDropZoneLeave) {
            this.props.onDropZoneLeave(this);
        }

        this.setState({
            hasMouseInZone: false
        });
    };

    private mouseMoved = (event: React.MouseEvent) : void => {
        if(!this.props.dragActive) {
            return;
        }

        const bodyElement: any = this.bodyRef.current;

        let closestIndex = 0;
        let closestDistance = 1e9;
        const filter = (e: any) : boolean => e.classList.contains("Timeline__separator");
        const filteredChildren = Array.from<any>(bodyElement.children).filter(filter);
        filteredChildren.forEach((child, index) => {
            const boundingRect = child.getBoundingClientRect();

            const distance = Math.abs(event.pageY - boundingRect.top+window.scrollY);
            if(distance < closestDistance) {
                closestIndex = index;
                closestDistance = distance;
            }
        });

        this.setState({
            activeSeparatorIndex: closestIndex
        });
    };

    private dragStarted = (event: React.MouseEvent, object: IDraggable) => {
        if(object instanceof TimelineCard) {
            const index: number = this.state.instances.indexOf(object.props.toolInstance);
            if(index > -1) {
                const copy = this.state.instances;
                copy.splice(index, 1);
                this.setState({
                    instances: copy
                });
            }
        }

        if(this.props.onDragStart) {
            this.props.onDragStart(event, object);
        }
    }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/App/Blocks/Timeline.tsx